import { render, staticRenderFns } from "./AgencyPurchaseServiceFee.vue?vue&type=template&id=68ba7c4c&scoped=true&"
import script from "./AgencyPurchaseServiceFee.vue?vue&type=script&lang=js&"
export * from "./AgencyPurchaseServiceFee.vue?vue&type=script&lang=js&"
import style0 from "./AgencyPurchaseServiceFee.vue?vue&type=style&index=0&id=68ba7c4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ba7c4c",
  null
  
)

export default component.exports